import api from 'common/api'
import { Audience, Bucket } from '../types'
import { Action } from './reducer'

interface CountMetrics {
  count: number
  countPercentChange: number
}

interface RateMetrics {
  rate: number
  ratePrev: number
}

export interface CollegePremiumInsightsResponseMetrics {
  percent: number
  percentChange: number
  yearlyPercentChange: number
  total: number
  totalChange: number
  yearlyTotalChange: number
}

export interface GetCollegePremiumInsightsResponse {
  scid: number
  updatedAt: string
  countMetrics: {
    impressions: CountMetrics
    totalEngagement: CountMetrics
    profileVisits: CountMetrics
    usersReached: CountMetrics
    follows: CountMetrics
    referredTraffic: CountMetrics
  }
  rateMetrics: {
    totalEngagement: RateMetrics
    profileVisits: RateMetrics
    follows: RateMetrics
    referredTraffic: RateMetrics
  }
}

export default async function getCollegePremiumInsights({
  scid,
  audience,
  bucket,
  dispatch,
}: {
  scid: number
  audience: Audience
  bucket: Bucket
  dispatch: React.Dispatch<Action>
}) {
  dispatch({ type: 'GET_COLLEGE_PREMIUM_INSIGHTS_REQUEST', payload: { status: 'loading' } })

  try {
    const data = await api.get<GetCollegePremiumInsightsResponse>(
      `/api/colleges/${scid}/premium-insights?audience=${audience}&bucket=${bucket}`,
    )

    dispatch({
      type: 'GET_COLLEGE_PREMIUM_INSIGHTS_REQUEST',
      payload: {
        status: 'success',
        data,
      },
    })
  } catch (error) {
    dispatch({ type: 'GET_COLLEGE_PREMIUM_INSIGHTS_REQUEST', payload: { status: 'error', error } })
    throw error
  }
}
